/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledCreditsListWrapper = styled.div`
  display: block;
`;
